import { Box, Typography } from "@mui/material";
import React from "react";
import CarBot from "../../../shared/icons/CarBot.svg";

const Logo: React.FC<{ width: number; height: number }> = ({
  width,
  height,
}) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    <img src={CarBot} alt="CarBot Logo" style={{ width, height }} />
    <Typography
      variant="h5"
      sx={{
        color: "#eb5f0a",
        fontWeight: 500,
        fontFamily: "serif",
        letterSpacing: 1,
      }}
    ></Typography>
  </Box>
);

export default Logo;
